<template>
    <div class="page resetPass">
        <div class="container  min-h-100 d-flex flex-column pt-4">
            <div class="row">
                <div class="col-12">
                    
                    <div class="resetForm">
                        <h2 class="ktdarkchoc text-center mediaHideOnDesctop">
                            Let’s get you a new password
                        </h2>
                        <div class="descktopMediaBox">
                            <div class="h1 text-center">
                                Let’s get you a new password
                            </div>
                        </div>
                        <input
                            :type="type ? 'tel' : 'email' "
                            :placeholder="type ? 'Phone Number' : 'Email Address' "
                            @keyup.enter="sendEmail"
                            @input="acceptNumber"
                            v-model="email"
                        >
                        <div class="disclamer">
                            <div class="caption ktdarkchoc" v-if="type">
                                Check your text messages for a temporary password, that you can change once you’re logged in.
                            </div>
                            <div class="caption ktdarkchoc" v-else>
                                Check your email for a temporary password, that you can change once you’re logged in.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-auto mt-lg-4">
                <div class="col-12">
                    <div class="btnBox">
                        <a class="btnlink zbg" @click="resetPassword">
                            <span v-if="type">Send to my number</span>
                            <span v-else>Send to my email</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
</template>

<script>
    export default {
        name: "AccountLookup",
        data() {
            return {
                email: "",
                success: false,
                type: false
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Account Lookup", showBackButton: true});
            if (this.$route.params.type === "email") {
                this.type = false;
            } else {
                this.type = true
            }
        },
        methods: {
            acceptNumber() {
                if (this.type) {
                    var x = this.email.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    this.email = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                }
            },
            resetPassword() {
                this.$store.dispatch("user/resetPassword", {type: this.type, email: this.email})
            }
        }
    }
</script>
